import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-view-co-ordinates',
  templateUrl: './view-co-ordinates.component.html',
  styleUrls: ['./view-co-ordinates.component.scss']
})
export class ViewCoOrdinatesComponent implements OnInit {
  overlays: google.maps.Marker[] = [];
  gpsData: string = '/assets/gpsLocations/gpsData3.xlsx';
  jsonData: any;
  dataString: string;
  options: { center: { lat: number; lng: number; }; zoom: number; };
  userID: any;

  constructor(
    private httpClient: HttpClient,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
    ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'Field Survey Map View', '', new Date(), 'Success');

    // this.overlays = [
    //   new google.maps.Marker({ position: { lat: 36.879466, lng: 30.667648 }, title: "Konyaalti" }),
    //   new google.maps.Marker({ position: { lat: 36.883707, lng: 30.689216 }, title: "Ataturk Park" }),
    //   new google.maps.Marker({ position: { lat: 36.885233, lng: 30.702323 }, title: "Oldtown" }),
    // ];
    this.options = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 6
    };

    this.loader.start();
    this.httpClient.get(this.gpsData, { responseType: 'blob' })
      .subscribe((data: any) => {
        this.loader.close();
        let workBook: any = null;
        let jsonData = null;
        const reader: FileReader = new FileReader();
        reader.onload = (event) => {
          const data = reader.result;
          workBook = XLSX.read(data, { type: 'binary' });
          jsonData = workBook.SheetNames.reduce((initial: any, name: any) => {
            const sheet = workBook.Sheets[name];
            initial[name] = XLSX.utils.sheet_to_json(sheet);
            return initial;
          }, {});
          const dataString = JSON.stringify(jsonData);
          JSON.parse(dataString).Sheet1.splice(0, 100).forEach(row => {
            this.addOverlay(row)
          });
        }
        reader.readAsBinaryString(data);
      });
  }
  addOverlay(row: any) {
    this.overlays.push(new google.maps.Marker({ position: { lat: row?.EstLat, lng: row?.EstLong }, title: row?.Name }))
  }

}
